module.exports = __webpack_public_path__ + "img/arrow-down.c11fbdb5.svg";